import React from 'react';

/**
 * @author 이현우
 * @returns
 */
const UntactStep2 = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.44092 19.9384H5.32988L19.59 5.67827L15.7006 1.78931L1.44092 16.0494V19.9384Z"
        stroke="white"
        strokeWidth="2.0625"
        strokeLinejoin="round"
      />
      <path
        d="M11.8125 5.67798L15.7015 9.56694"
        stroke="white"
        strokeWidth="2.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UntactStep2;
